/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1201_RecvEditor extends Serenity.Extensions.GridEditorBase<Report_1201_RecvRow> {
        protected getColumnsKey() { return Report_1201_RecvColumns.columnsKey; }
        // protected getDialogType() { return Report_1201_RecvDialog; }
        protected getLocalTextPrefix() { return Report_1201_RecvRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
                       
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

